import type { UseQueryOptions } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';
import { fetchFromAPI } from '~/api/utils';

const queryKey = 'shopifyCurrencyRates';

export interface ICurrencyRates {
  [key: string]: number;
}

export interface ShopifyCurrencyRateQueryResponse {
  data: ICurrencyRates;
}

export const useQueryShopifyCurrencyRates = <
  TError = Error,
  TData = ShopifyCurrencyRateQueryResponse,
>(
  variables?: undefined,
  options?: UseQueryOptions<ShopifyCurrencyRateQueryResponse, TError, TData>,
) => {
  return useQuery<ShopifyCurrencyRateQueryResponse, TError, TData>({
    queryKey: [queryKey, variables],
    queryFn: () => fetchFromAPI('/api/shopify/currencies', { method: 'GET' }),
    ...options,
  });
};

useQueryShopifyCurrencyRates.getKey = (variables: undefined) => [queryKey, variables];
